export default __webpack_public_path__ + "media/images/main/select2x2-311e874281e444ccdaad467943e2dc94.png";